var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notfound-container"},[_c('h1',[_vm._v("Page not found")]),_c('p',[_vm._v("The page you are looking for does not exist.")]),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Return to home")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }